import React from 'react';
import { Calendar, Phone, Star } from 'lucide-react';
import { Button } from './ui/button';
import { heroImage, clinicInfo } from '../mock';

export const Hero = () => {
  const scrollToAppointment = () => {
    const element = document.getElementById('appointment');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroImage} 
          alt="Dental clinic" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/95 via-emerald-800/90 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-2 mb-6">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={20} fill="#fbbf24" stroke="#fbbf24" />
              ))}
            </div>
            <span className="text-white font-semibold">5.0 Rating from 500+ Happy Patients</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Your Perfect Smile
            <span className="block text-emerald-300">Starts Here</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-100 mb-8 leading-relaxed">
            Experience compassionate, world-class dental care with cutting-edge technology. 
            We make your comfort and confidence our top priority.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button 
              size="lg"
              onClick={scrollToAppointment}
              className="bg-white text-emerald-700 hover:bg-emerald-50 text-lg px-8 py-6 h-auto font-semibold shadow-xl"
            >
              <Calendar className="mr-2" size={24} />
              Book Appointment
            </Button>
            <Button 
              size="lg"
              variant="outline"
              onClick={() => window.location.href = `tel:${clinicInfo.phone}`}
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-emerald-700 text-lg px-8 py-6 h-auto font-semibold"
            >
              <Phone className="mr-2" size={24} />
              Call Now
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 max-w-2xl">
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">15+</div>
              <div className="text-gray-200 text-sm">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">15</div>
              <div className="text-gray-200 text-sm">Specialized Services</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">100%</div>
              <div className="text-gray-200 text-sm">Patient Satisfaction</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};
